/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * This file contains the component that provides context for the online patient
 * management system.
 * ---------------------------------------------------------------------------------
 */

/*
 * ----------------------------------------------------------------------------------
 * Imports - External
 * ----------------------------------------------------------------------------------
 */

/*
 * Required to use React components.
 */
import React, { ReactNode, useContext, useEffect, useMemo, useState } from 'react';


/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

import { Field as CoreField, FormErrorActionContext, FormErrorContext, IFieldContext, IFieldProps as ICoreFieldProps } from '@ngt/forms-core';
import { FormError } from '../../../errors';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */

/**
 * This interface defines the properties for the Field component.
 */
export interface IFieldProps<TValue = any, TFormValue extends object = any> extends ICoreFieldProps<TValue, TFormValue, FormError> {
}

/*
 * ---------------------------------------------------------------------------------
 * Components
 * ---------------------------------------------------------------------------------
 */

/**
 * This component provides context for the patient management system.
 * @param param0 component properties.
 */
const Field = <TValue extends any = any, TFormValue extends object = any>({
    children,
    ...fieldBaseProps
}: IFieldProps<TValue, TFormValue>) => {
    return (
        <CoreField
            {...fieldBaseProps}
        >
            {children}
        </CoreField>
    );
}

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default Field;